interface WebsiteCardProps {
  name: string;
  url: string;
  description: string;
  tags: string[];
  rating: number;
  image: string;
}

export default function WebsiteCard({ name, url, description, tags, rating, image }: WebsiteCardProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="group block bg-white rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full h-40 overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
        />
        <div className="absolute top-3 right-3 flex items-center gap-1 bg-white/90 backdrop-blur px-2 py-1 rounded-full">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-xs font-medium text-foreground-800">{rating}</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
          {name}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
          {description}
        </p>
        <div className="flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-background-100 text-foreground-600 text-xs rounded-md whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
}